import { render, staticRenderFns } from "./BusinessReject.vue?vue&type=template&id=da91477c"
import script from "./BusinessReject.vue?vue&type=script&lang=js"
export * from "./BusinessReject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormSiteInput: require('/opt/atlassian/pipelines/agent/build/components/form/SiteInput.vue').default,FormSiteButton: require('/opt/atlassian/pipelines/agent/build/components/form/SiteButton.vue').default})
